import { mapActions, mapState } from 'vuex'
import { ErrorHelper } from '@/helpers/ErrorHelper'
import { SelectedSiteIdMixin } from './SelectedSiteIdMixin'

export const ClientAddressCacheMixin = {
  mixins: [SelectedSiteIdMixin],
  data () {
    return {
      error: ''
    }
  },
  computed: {
    ...mapState('ClientAddress', [
      'loadingClientAddress',
      'loadedClientAddress',
      'clientAddress'
    ])
  },
  watch: {
    selectedSiteId () {
      this.refreshClientAddress()
    }
  },
  methods: {
    ...mapActions('ClientAddress', [
      'fetchClientAddressBySiteId'
    ]),
    refreshClientAddress () {
      if (!this.loadedClientAddress && this.selectedSiteId) {
        this.tryFetchClientAddress()
      }
    },
    tryFetchClientAddress () {
      const self = this
      if (self.loadingClientAddress) {
        return
      }
      self.fetchClientAddressBySiteId(self.selectedSiteId)
        .catch(error => { self.error = ErrorHelper.getError(error) })
    }
  },
  created () {
    this.refreshClientAddress()
  }
}
